var exports = {
  "Lw": "xdbfd91f1--ac1305--overlay",
  "p6": "xdbfd91f1--ac1305--date",
  "VN": "xdbfd91f1--ac1305--close",
};

module.exports = exports;
